import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { DashboardSliceDataInterface, DashboardSliceInterface } from './dasboardSlice.interface';

const initialState: DashboardSliceInterface = {
  loading: true,
  data: null,
  meta: null,
  error: null,
  tiers: null,
  user: null,
  toBeExpireTransactions: null,
  latestActivity: null,
};

export const dashboardSlice = createSlice({
  name: 'Dashboard',
  initialState,
  reducers: {
    setDashboardData: (state, action: PayloadAction<DashboardSliceDataInterface>) => {
      state.tiers = action.payload.tiers;
      state.user = action.payload.user;
      state.toBeExpireTransactions = action.payload.toBeExpireTransactions;
      state.latestActivity = action.payload.latestActivity;
      state.loading = false;
      state.error = null;
    },

    setDashboardLoading(state) {
      state.loading = true;
    },

    setDashboardError(state, action: PayloadAction<any>) {
      state.tiers = null;
      state.user = null;
      state.toBeExpireTransactions = null;
      state.latestActivity = null;
      state.loading = false;
      state.error = action.payload;
    },
    resetDashboard(state) {
      state.tiers = initialState.tiers;
      state.user = initialState.user;
      state.toBeExpireTransactions = initialState.toBeExpireTransactions;
      state.latestActivity = initialState.latestActivity;
    },
  },
});

export const { setDashboardData, setDashboardLoading, setDashboardError, resetDashboard } = dashboardSlice.actions;

export const dashboardLoadingState = (state: RootState) => state.dashboard.loading;
export const tierState = (state: RootState) => state.dashboard.tiers;
export const lastActivitiesState = (state: RootState) => state.dashboard.latestActivity;
export const toBeExpireTransactionsState = (state: RootState) => state.dashboard.toBeExpireTransactions;
export const dashboardUserInfoState = (state: RootState) => state.dashboard.user;

export default dashboardSlice.reducer;
